export const LOGGER_FRAGMENT_ID = 'es-fragment-design-services-dashboard';
export const TRACKING_CALLER = 'designservices-redirect';
